import { googleOauth } from 'customer/context';
import _ from 'lodash';
import React from 'react';
import * as oauth from 'oauth';
import Button from 'react-bootstrap/Button';
import { ReactComponent as GpcOrgIcon } from 'images/google-domain.svg';

import * as queries from 'hooks/queries';
import { useSignout } from 'hooks/signout';

export const CustomerGoogleAuthStatus = () => {
  const { setGoogleOauthStatus } = React.useContext(googleOauth) || {};
  const { signOut } = useSignout(setGoogleOauthStatus);

  const { email } = oauth.getCurrentUser() || {};
  const { data } = queries.useQueryIsOnboarded();
  const isOnboarded = _.get(data, 'isOnboarded', false);
  const orgDisplayName = _.get(data, 'organizationClaims.organizations[0].gcpDisplayName', '');

  return email ? (
    <section className="bg-gray50 py-4 shadow-sm">
      <div className="rax-mgcp-logged-in-as container">
        <GpcOrgIcon className="icon" />
        <div className="account-email">
          <strong aria-label="GCP Email">{email}</strong>
          <div className="switch-account">
            <Button onClick={signOut} size="sm" variant="link" className="p-0">Switch account</Button>
          </div>
        </div>
        {isOnboarded
          && (
          <div aria-label="GCP Organization" className="account-org">
            {orgDisplayName}
          </div>
          )}
      </div>
    </section>
  ) : null;
};
